import {
  Box,
  TextField,
  Button,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  type SelectChangeEvent,
} from "@mui/material";
import { Search, FilterList, Clear } from "@mui/icons-material";
import {
  alliancesSortValue,
  ALLIANCES_DEFAULT_SORT_BY,
  ALLIANCES_DEFAULT_SORT_ORDER,
} from "../utils/alliancesSearchParams";

const DEFAULT_SORT = alliancesSortValue(
  ALLIANCES_DEFAULT_SORT_BY,
  ALLIANCES_DEFAULT_SORT_ORDER,
);

const SORT_OPTIONS: { value: string; label: string }[] = [
  { value: "details.name|asc", label: "Naziv (A-Ž)" },
  { value: "details.name|desc", label: "Naziv (Ž-A)" },
  { value: "details.sport|asc", label: "Sport (A-Ž)" },
  { value: "details.sport|desc", label: "Sport (Ž-A)" },
  { value: "coverage|asc", label: "Pokrivenost (prvo manja)" },
  { value: "coverage|desc", label: "Pokrivenost (prvo veća)" },
];

interface SearchFilterProps {
  search: string;
  sortValue: string;
  onSearchChange: (value: string) => void;
  onSortChange: (sortValue: string) => void;
  onApply: () => void;
  onReset: () => void;
}

export function SearchFilter({
  search,
  sortValue,
  onSearchChange,
  onSortChange,
  onApply,
  onReset,
}: SearchFilterProps) {
  const handleSortChange = (e: SelectChangeEvent<string>) => {
    onSortChange(e.target.value);
  };

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5, md: 3 },
        bgcolor: "background.paper",
        borderRadius: 2,
        border: 1,
        borderColor: "divider",
        mb: { xs: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: 2,
          alignItems: { xs: "stretch", lg: "flex-start" },
        }}
      >
        <TextField
          fullWidth
          size="small"
          placeholder="Pretraži saveze (naziv, sport, ključne riječi…)"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onApply()}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
          }}
          sx={{ flex: { lg: 1 }, minWidth: 0 }}
        />

        <FormControl
          size="small"
          sx={{
            minWidth: { xs: "100%", sm: 240, lg: 260 },
            flexShrink: 0,
          }}
        >
          <InputLabel id="pretraga-poredaj-label">Poredaj</InputLabel>
          <Select
            labelId="pretraga-poredaj-label"
            id="pretraga-poredaj"
            label="Poredaj"
            value={sortValue || DEFAULT_SORT}
            onChange={handleSortChange}
          >
            {SORT_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
            flexShrink: 0,
            width: { xs: "100%", lg: "auto" },
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            startIcon={<FilterList />}
            onClick={onApply}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Filtriraj
          </Button>
          <Button
            variant="outlined"
            startIcon={<Clear />}
            onClick={onReset}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Poništi
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
